import { graphql } from '~/gql'

const BUCKET_FRAGMENT = graphql(`
  fragment BucketFragment on Bucket {
    url
  }
`)

export default BUCKET_FRAGMENT
